import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth';
import { AppShell } from '@/components/layout/AppShell';

export const Route = createFileRoute('/_authed')({
  beforeLoad: () => {
    if (!useAuth.getState().session) throw redirect({ to: '/login' });
  },
  component: AppShell,
});
